(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retro-promo-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      root.querySelectorAll('[data-retro-promo-banner]').forEach((banner) => {
        if (banner.dataset.retroPromoReady === 'true') return;
        banner.dataset.retroPromoReady = 'true';

        banner.addEventListener('pointermove', (event) => {
          const bounds = banner.getBoundingClientRect();
          const x = ((event.clientX - bounds.left) / bounds.width) * 100;
          const y = ((event.clientY - bounds.top) / bounds.height) * 100;
          banner.style.setProperty('--retro-promo-spot-x', `${x}%`);
          banner.style.setProperty('--retro-promo-spot-y', `${y}%`);
        });
      });
    };

    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rfs-barcelona-1415-editorial-current"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-rfs-patch-jump]');
    if (!trigger) return;

    const target = document.querySelector('.patch-products-list');
    if (!target) return;

    const expandable = target.closest('details');
    if (expandable) expandable.open = true;

    let scope = target;
    let toggle = null;
    for (let level = 0; level < 6 && scope && !toggle; level += 1) {
      scope = scope.parentElement;
      if (scope) toggle = scope.querySelector('button[aria-expanded]');
    }
    if (toggle && toggle.getAttribute('aria-expanded') === 'false') toggle.click();

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.requestAnimationFrame(() => {
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });

      const focusable = target.querySelector('input, button, [tabindex]');
      if (focusable) window.setTimeout(() => focusable.focus({ preventScroll: true }), reduceMotion ? 0 : 550);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rfs-blog-guides"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeGuideSection = (section) => {
      if (!section || section.dataset.rfsBlogGuidesReady === 'true') return;

      const track = section.querySelector('[data-rfs-guides-track]');
      const previousButton = section.querySelector('[data-rfs-guides-prev]');
      const nextButton = section.querySelector('[data-rfs-guides-next]');
      const firstCard = track && track.querySelector('.rfs-blog-guides__card');

      if (!track || !previousButton || !nextButton || !firstCard) return;

      section.dataset.rfsBlogGuidesReady = 'true';

      const getStep = () => firstCard.getBoundingClientRect().width + 16;
      const updateControls = () => {
        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };

      previousButton.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      nextButton.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls);
      updateControls();
    };

    document.querySelectorAll('[data-rfs-blog-guides]').forEach(initializeGuideSection);

    document.addEventListener('shopify:section:load', (event) => {
      initializeGuideSection(event.target.querySelector('[data-rfs-blog-guides]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
